import React, {Component} from 'react'
import Link from '../links/Link'
import AddNewLink from '../links/AddNewLink'

export default class Category extends Component {

    constructor(props) {
        super(props)
        this.state = {
            name: props.name,
            position: props.position,
            links: props.links
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            name: nextProps.name,
            position: nextProps.position,
            links: nextProps.links
        })
    }

    handleCloneCategory = () => {
        this.props.http.cloneLast(this.props.id, this.props.refreshLinks)
    };

    handleRemoveCategory = () => {
        this.props.http.removeCategory(this.props.id, this.props.refreshLinks)
    };

    handleCategoryUp = () => {
        this.props.http.categoryUp(this.props.id, this.props.refreshLinks)
    };

    handleCategoryDown = () => {
        this.props.http.categoryDown(this.props.id, this.props.refreshLinks)
    };

    handleAddLink(linkData) {
        linkData.details = true;
        let oldLinks = this.state.links;
        this.setState({ links: [...oldLinks, linkData] })
    }
     
    render() {
        return (
            <tbody className="container" ref={this.props.dragulaDecorator} id={"cat" + this.props.id}>
                <tr>
                    <td style={{backgroundColor: '#eee'}}>
                        <em>{this.props.name}</em>
                        <img src="/img/copy-paste-document.svg" name="clone-last" alt="Clone last"
                             style={{float: "right", pointer: "cursor", padding: "2px",
                                 width: "23px", height: "23px"}}
                             onClick={this.handleCloneCategory}/>
                        <img src="/img/remove.svg" name="remove" alt="Remove category"
                             style={{float: "right", pointer: "cursor", padding: "2px",
                                 width: "23px", height: "23px"}}
                             onClick={this.handleRemoveCategory}/>
                        <img src="/img/up.svg" name="up" alt="Move up"
                             style={{float: "right", pointer: "cursor", padding: "3px", marginRight: "5px",
                                 width: "23px", height: "23px"}}
                             onClick={this.handleCategoryUp}/>
                        <img src="/img/down.svg" name="down" alt="Move down"
                             style={{float: "right", pointer: "cursor", padding: "3px", marginRight: "5px",
                                 width: "23px", height: "23px"}}
                             onClick={this.handleCategoryDown}/>
                    </td>
                </tr>
                {
                    this.state.links.map(link => <Link key={link.id}
                                                       updateLink={this.props.http.updateLink}
                                                       deleteLink={this.props.http.deleteLink}
                                                       refreshLinks={this.props.refreshLinks}
                                                       lookupTwitterHandle={this.props.http.lookupTwitterHandleForAuthor}
                                                       {...link}/>)
                }
                <AddNewLink categoryId={this.props.id}
                            http={this.props.http}
                            addToCategory={this.handleAddLink.bind(this)} />
            </tbody>
        )
    }
}

Category.propTypes = {
    id: React.PropTypes.number.isRequired,
    links: React.PropTypes.array,
    http: React.PropTypes.object.isRequired,
    refreshLinks: React.PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/dashboard/categories/Category.js